import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ComicCard from '@/components/feature/ComicCard';
import SEOHead from '@/components/feature/SEOHead';
import SEOSchema from '@/components/feature/SEOSchema';
import { comics, categories } from '@/mocks/comics';

export default function Home() {
  const hotComics = comics.filter((c) => c.isHot).slice(0, 6);
  const newComics = comics.filter((c) => c.isNew).slice(0, 6);
  const latestComics = [...comics].sort(
    (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
  ).slice(0, 8);

  return (
    <>
      <SEOHead
        title="韩漫网站-无删减韩漫在线观看-漫画韩漫网址-免费韩国漫画大全"
        description="韩漫网站支持无删减韩漫在线观看，整合漫画韩漫网址资源，免费韩国漫画大全涵盖各种题材，从爱情到悬疑，为您提供全面而丰富的阅读选择。"
        keywords="韩漫网站,无删减韩漫在线观看,漫画韩漫网址,免费韩国漫画大全"
        canonicalUrl="https://www.manhuakr.com/"
      />
      <SEOSchema
        type="WebPage"
        data={{
          name: '韩漫大全 - 首页',
          description: '韩漫网站支持无删减韩漫在线观看，整合漫画韩漫网址资源',
          url: 'https://www.manhuakr.com/',
          inLanguage: 'zh-CN',
          isPartOf: {
            '@type': 'WebSite',
            name: '韩漫大全',
            url: 'https://www.manhuakr.com/',
          },
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Hero Section */}
          <section className="relative h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20webtoon%20style%20illustration%20featuring%20multiple%20manga%20characters%20in%20dynamic%20action%20poses%2C%20comic%20book%20aesthetic%2C%20warm%20vibrant%20colors%20with%20deep%20red%20and%20golden%20accents%2C%20epic%20cinematic%20composition%2C%20artistic%20brush%20strokes%2C%20dark%20atmospheric%20background%20with%20dramatic%20lighting&width=1800&height=900&seq=hero-bg-manhwa&orientation=landscape"
              alt="韩漫大全 - 无删减韩漫在线观看"
              title="韩漫网站 - 免费韩国漫画大全"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-background-50"></div>
            <div className="relative z-10 w-full text-center px-4">
              <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-white mb-4 leading-tight">
                无删减韩漫在线观看
              </h1>
              <p className="text-foreground-100 text-sm md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
                免费韩国漫画大全，涵盖爱情、悬疑、奇幻、动作等多种题材，为您提供全面而丰富的阅读选择。原汁原味，高清画质。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <Link
                  to="/category/all"
                  className="bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer text-sm"
                >
                  立即阅读
                </Link>
                <Link
                  to="/about"
                  className="border border-foreground-100/30 hover:border-foreground-100/60 text-foreground-50 px-8 py-3 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer text-sm"
                >
                  了解更多
                </Link>
              </div>
            </div>
          </section>

          {/* Category Navigation */}
          <section className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-6">
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50">
                  漫画分类
                </h2>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
                    className="flex flex-col items-center gap-2 p-4 rounded-lg bg-background-100 hover:bg-background-200/70 border border-background-200/70 hover:border-primary-500/30 transition-all cursor-pointer group"
                  >
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-400 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                      <i className={`${cat.icon} text-lg`}></i>
                    </div>
                    <span className="text-foreground-300 text-xs font-medium group-hover:text-foreground-50 transition-colors whitespace-nowrap">
                      {cat.name}
                    </span>
                  </Link>
                ))}
              </div>
            </div>
          </section>

          {/* Hot Comics */}
          <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100/50">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50">
                    热门推荐
                  </h2>
                  <p className="text-foreground-500 text-xs mt-1">最受读者欢迎的韩漫作品</p>
                </div>
                <Link
                  to="/category/all"
                  className="text-primary-400 hover:text-primary-300 text-sm flex items-center gap-1 transition-colors whitespace-nowrap"
                >
                  查看全部
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4" data-product-shop>
                {hotComics.map((comic) => (
                  <ComicCard key={comic.id} comic={comic} />
                ))}
              </div>
            </div>
          </section>

          {/* Latest Updates */}
          <section className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50">
                    最新更新
                  </h2>
                  <p className="text-foreground-500 text-xs mt-1">实时同步最新韩漫章节</p>
                </div>
                <Link
                  to="/category/all"
                  className="text-primary-400 hover:text-primary-300 text-sm flex items-center gap-1 transition-colors whitespace-nowrap"
                >
                  查看全部
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-4" data-product-shop>
                {latestComics.map((comic) => (
                  <ComicCard key={comic.id} comic={comic} />
                ))}
              </div>
            </div>
          </section>

          {/* New Arrivals */}
          <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100/50">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50">
                    新作上架
                  </h2>
                  <p className="text-foreground-500 text-xs mt-1">最新引进的韩漫作品</p>
                </div>
                <Link
                  to="/category/all"
                  className="text-primary-400 hover:text-primary-300 text-sm flex items-center gap-1 transition-colors whitespace-nowrap"
                >
                  查看全部
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4" data-product-shop>
                {newComics.map((comic) => (
                  <ComicCard key={comic.id} comic={comic} />
                ))}
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="relative py-16 md:py-20 px-4 md:px-6 overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=A%20warm%20atmospheric%20reading%20nook%20with%20bookshelves%20filled%20with%20comics%2C%20soft%20ambient%20lighting%2C%20cozy%20modern%20interior%2C%20warm%20wooden%20tones%2C%20Korean%20manhwa%20aesthetic%2C%20comfortable%20reading%20space%2C%20artistic%20composition&width=1800&height=600&seq=cta-bg-manhwa&orientation=landscape"
              alt=""
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-background-950/70"></div>
            <div className="relative z-10 max-w-3xl mx-auto text-center">
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-50 mb-4">
                开启你的韩漫阅读之旅
              </h2>
              <p className="text-foreground-300 text-sm md:text-base mb-8 max-w-xl mx-auto">
                5000+ 部精选韩漫作品，每日更新，高清画质。加入我们，发现更多精彩故事。
              </p>
              <Link
                to="/category/all"
                className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-book-open-line"></i>
                立即免费阅读
              </Link>
            </div>
          </section>

          {/* FAQ Section */}
          <section className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
            <div className="max-w-4xl mx-auto">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50 text-center mb-8">
                常见问题
              </h2>
              <div className="space-y-3">
                {[
                  {
                    q: '韩漫大全上的漫画都是正版吗？',
                    a: '是的，我们平台上的所有韩国漫画均经过正版授权，确保内容合法合规。我们与多家韩国知名漫画出版社建立了长期合作关系。',
                  },
                  {
                    q: '如何开始阅读？',
                    a: '只需浏览我们的漫画分类或使用搜索功能找到您喜欢的作品，点击即可开始阅读，无需注册账号。',
                  },
                  {
                    q: '支持手机阅读吗？',
                    a: '韩漫大全完美支持手机、平板和电脑端阅读，针对不同设备都做了专门的适配优化。',
                  },
                  {
                    q: '漫画更新频率如何？',
                    a: '热门连载作品通常每周更新1-2话，我们会在第一时间同步更新，让您不错过任何精彩内容。',
                  },
                ].map((faq, index) => (
                  <details
                    key={index}
                    className="group bg-background-100 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer"
                  >
                    <summary className="flex items-center justify-between px-5 py-4 text-foreground-50 font-medium text-sm list-none">
                      {faq.q}
                      <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform text-foreground-400"></i>
                    </summary>
                    <div className="px-5 pb-4 text-foreground-400 text-sm leading-relaxed">
                      {faq.a}
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </section>

          <SEOSchema
            type="FAQPage"
            data={{
              mainEntity: [
                {
                  '@type': 'Question',
                  name: '韩漫大全上的漫画都是正版吗？',
                  acceptedAnswer: { '@type': 'Answer', text: '是的，我们平台上的所有韩国漫画均经过正版授权，确保内容合法合规。' },
                },
                {
                  '@type': 'Question',
                  name: '如何开始阅读？',
                  acceptedAnswer: { '@type': 'Answer', text: '只需浏览我们的漫画分类或使用搜索功能找到您喜欢的作品，点击即可开始阅读，无需注册账号。' },
                },
                {
                  '@type': 'Question',
                  name: '支持手机阅读吗？',
                  acceptedAnswer: { '@type': 'Answer', text: '韩漫大全完美支持手机、平板和电脑端阅读，针对不同设备都做了专门的适配优化。' },
                },
                {
                  '@type': 'Question',
                  name: '漫画更新频率如何？',
                  acceptedAnswer: { '@type': 'Answer', text: '热门连载作品通常每周更新1-2话，我们会在第一时间同步更新。' },
                },
              ],
            }}
          />
        </main>

        <Footer />
      </div>
    </>
  );
}